import { Sparkles, ArrowRight } from "lucide-react";
import { FacebookIcon } from "@/components/icons/facebook";
import { GoogleIcon } from "@/components/icons/google";
import { TikTokIcon } from "@/components/icons/tiktok";
import { PinterestIcon } from "@/components/icons/pinterest";

import { Button } from "@/components/ui/button";

const platformBadges = [
  { name: "Meta", Icon: FacebookIcon },
  { name: "Google", Icon: GoogleIcon },
  { name: "TikTok", Icon: TikTokIcon },
  { name: "Pinterest", Icon: PinterestIcon },
];

export function UnlockCreativeCard() {
  return (
    <div className="rounded-2xl border border-border bg-background px-8 py-8 shadow-lg text-center space-y-4 max-w-sm w-full">
      <div className="mx-auto flex size-12 items-center justify-center rounded-xl bg-violet-100/40">
        <Sparkles className="size-6 text-violet-600" strokeWidth={2.5} />
      </div>
      <div className="space-y-1.5">
        <p className="text-base font-semibold text-foreground">Unlock creative intelligence</p>
        <p className="text-sm text-muted-foreground">Connect your ad platforms to see top performers, fatigue tracking, and AI recommendations.</p>
      </div>
      <Button className="gap-2 rounded-lg px-6">
        Connect Ad Platforms
        <ArrowRight className="size-4" strokeWidth={2.5} />
      </Button>
      <div className="flex items-center justify-center gap-2 pt-1">
        {platformBadges.map((badge) => (
          <div key={badge.name} className="flex size-9 items-center justify-center rounded-full bg-card ring-1 ring-border" title={badge.name}>
            <badge.Icon className="size-5" aria-label={badge.name} />
          </div>
        ))}
      </div>
    </div>
  );
}
